// LIA's live activity (owner request 2026-11-03; context/v1.1 ficha «tareas de LÍA para hoy y vencidas»): recent
// steps + the opportunity tasks, and a server-sent event stream of new/updated steps and tasks. Schemas: api-activity.ts.
import { z } from 'zod';
import * as A from './api-activity.js';
import { route, Ws } from './route-def.js';

export const activityRoutes = {
  getActivity: route({
    method: 'GET', path: '/workspaces/:workspaceId/activity', summary: 'Actividad de LIA: pasos recientes y tareas de las oportunidades', tag: 'activity',
    minRole: 'advisor', params: Ws, query: A.ActivityQuerySchema, response: A.ActivityFeedSchema,
  }),
  streamActivity: route({
    method: 'GET', path: '/workspaces/:workspaceId/activity/stream', summary: 'Actividad de LIA en vivo (server-sent events: activity, task)', tag: 'activity',
    minRole: 'advisor', params: Ws, query: A.ActivityQuerySchema, response: z.string(), produces: 'text/event-stream',
  }),
} as const;
